import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ItemService from './item'
import { Skeleton } from '@chakra-ui/react'

export default function Services() {
  const [service, setService] = useState()
  const { user } = useSelector((state) => state.userReducer)

  useEffect(() => {
    if (typeof window !== 'undefined' && user) {
      setService(user?.commande)
    }
  }, [user])

  return (
    <div>
      <div className=" mt-3 flex-col">
        <div className="text-2xl font-bold text-muted opacity-50">
          <h2>Mes Services</h2>
        </div>{' '}
        {!service ? (
          <div className="mx-auto   bg-white  my-2 flex-col">
            <Skeleton height="100px" className="w-full" />
            <Skeleton height="100px" className="w-full mt-2" />
            <Skeleton height="100px" className="w-full mt-2" />
          </div>
        ) : (
          <div>
            {service.length > 0 ? (
              <div>
                {service.map((value, index) => {
                  return (
                    <ItemService
                      key={index}
                      {...value}
                      district={user?.district}
                      town={user?.town}
                    />
                  )
                })}
              </div>
            ) : (
              <div className=" p-3 bg-white  rounded">
                <h2 className="text-2xl  text-center  ">
                  Pas encore commande ?
                </h2>
                <div className="flex mx-auto my-2">
                  <button
                    onClick={() => {
                      window.location.href = '/demand'
                    }}
                    className="btn focus:bg-info btn-block bg-orange-500 text-white font-bold mx-auto"
                  >
                    Je Commande
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
